import type { SnippetMap } from "./types";

export const proxySnippets: SnippetMap = {
  python: ({ token }) => `import oo

# Make an API call through the proxy
result = oo.proxy(
    "v1/chat/completions",
    token="${token}",
    payload={
        "model": "gpt-4o-mini",
        "messages": [{"role": "user", "content": "Hello!"}]
    }
)
print(result)`,

  javascript: ({ token, baseUrl }) => `// Make an API call through the Double-O proxy
const response = await fetch(
  "${baseUrl}/api/proxy/v1/chat/completions",
  {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer ${token}",
    },
    body: JSON.stringify({
      model: "gpt-4o-mini",
      messages: [{ role: "user", content: "Hello!" }],
    }),
  }
);
const data = await response.json();
console.log(data);`,

  curl: ({ token, baseUrl }) =>
    `curl -X POST "${baseUrl}/api/proxy/v1/chat/completions" \\
  -H "Content-Type: application/json" \\
  -H "Authorization: Bearer ${token}" \\
  -d '{
    "model": "gpt-4o-mini",
    "messages": [{"role": "user", "content": "Hello!"}]
  }'`,

  r: ({ token, baseUrl }) => `library(httr2)

# Make an API call through the Double-O proxy
resp <- request("${baseUrl}/api/proxy/v1/chat/completions") |>
  req_method("POST") |>
  req_headers(Authorization = paste("Bearer", "${token}")) |>
  req_body_json(list(
    model = "gpt-4o-mini",
    messages = list(list(role = "user", content = "Hello!"))
  )) |>
  req_perform()

result <- resp_body_json(resp)
print(result)`,
};
